import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { DateTime } from 'luxon';
import { ReleaseElectoralCard } from 'front-office/view-models/release-electoral-card';
import { ElectoralCard } from 'shell/models/person/electoral-card';
import { reasons } from 'shell/components/shared/list-reasons';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { UserProfile } from 'shell/hooks/use-user-profile/types';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { formatElectoralState } from 'shell/utils/electoral-state-formatter';

export const transformerElectoralCard = (
  response: AxiosResponse<HttpResponse<ElectoralCard>>,
  dati3002?: ResponseAnprData,
  userProfile?: UserProfile
): ReleaseElectoralCard => {
  const data = response.data.payload || {};
  let motivoPreviousCard;
  if (data?.motivoRilascioTesseraPrecedente) {
    motivoPreviousCard = reasons?.find(
      (item) => item?.id === data?.motivoRilascioTesseraPrecedente
    )?.value;
  } else {
    motivoPreviousCard = undefined;
  }

  const person = transformPerson(
    dati3002?.risposta3002OK?.listaSoggetti?.datiSoggetto[0] || {},
    userProfile
  );

  const family = transformFamilyCoexistence(
    dati3002?.risposta3002OK?.listaSoggetti?.datiSoggetto[0] || {}
  );

  const citizenship = transformCitizenship(
    dati3002?.risposta3002OK?.listaSoggetti?.datiSoggetto[0] || {}
  );

  return {
    indicatoreListaC: data?.indicatoreListaC,
    indicatoreListaE: data?.indicatoreListaE,
    autorizzazioneDocumenti: data?.autorizzazioneDocumenti,
    personForm: person || undefined,
    family,
    citizenship,
    fiscalCode: data?.codiceFiscale || undefined,
    surname: data?.cognome || undefined,
    withoutSurname: !Boolean(data.cognome),
    name: data?.nome || undefined,
    withoutName: !Boolean(data?.nome),
    dossier: data?.fascicolo || undefined,
    electorState: formatElectoralState(data.stato || ''),
    inscriptionYear: data?.annoIscrizione
      ? DateTime.fromISO(data?.annoIscrizione).toFormat('yyyy')
      : undefined,
    section: data?.sezioneElettorale || undefined,
    sectionProgressive: data?.progressivoSezione || undefined,
    generalListNumber: data?.numeroListaGenerale || undefined,
    zone: data?.zona || undefined,
    room: data?.collegioCamera || undefined,
    roomUni: data?.collegioCameraUninominale || undefined,
    roomPluri: data?.collegioCameraPlurinominale || undefined,
    senate: data?.collegioSenato || undefined,
    senateUni: data?.collegioSenatoUninominale || undefined,
    senatePluri: data?.collegioSenatoPlurinominale || undefined,
    province: data?.collegioProvinciale || undefined,
    previousCardNumber: data?.numeroTesseraPrecedente || undefined,
    previousReleaseDate: data?.dataRilascioTesseraPrecedente
      ? DateTime.fromISO(data?.dataRilascioTesseraPrecedente).toFormat('dd/MM/yyyy')
      : undefined,
    previousReleaseReason: motivoPreviousCard,
    previousCardState: data?.descrizioneStatoTessera || undefined,
    newReleaseDate: DateTime.now().toFormat('dd/MM/yyyy'),
    blockError: data?.descrizioneErroreBloccante || undefined,
    nonBlockError: data?.descrizioneErroreNonBloccante || undefined,
    flagNewCard: data?.tesseraNuova || undefined,
    flagArchived: data?.tesseraArchviata || undefined,
    flagPodest: data?.annullamentoPOTDESTE || undefined,
    flagAire: data?.flagAIRE || undefined,
    flagAuthoriaztion: data?.flagAutorizzazzione || undefined,
    printCardState: data?.annullamentoPOTDESTE || undefined,
    placeOfBirth: data?.descrizioneLuogoNascita || undefined,
    provinceOfBirth: data?.provNazLuogoNascita || undefined,
    dateOfBirth: data?.dataNascita
      ? DateTime.fromISO(data?.dataNascita).toFormat('dd/MM/yyyy')
      : undefined,
    mayorName: data?.nomeSindaco || undefined,
    electoralSection: data?.sezioneElettorale || undefined,
    sectionAddress: data?.indirizzoSezione || undefined,
    addressName: data?.nomeVia || undefined,
    civic: data?.numeroCivico || undefined,
    crossed: data?.barrato || undefined,
    electoralSurname: data.cognomeElettore || undefined,
    electoralName: data.nomeElettore || undefined,
    codePlaceResidence: data.codiceLuogoResidenza || undefined,
    residenceDescription: data.descrizioneLuogoResidenza || undefined,
    provNatPlaceResidence: data.provNazLuogoResidenza || undefined,
    address: data.indirizzo || undefined,
    newReleaseReason:
      data.flagAIRE === '*' ? '7' : data.tesseraArchviata?.toUpperCase() === 'SI' ? '4' : undefined,
    anomalyList: data?.anomalieList?.map((item) => ({
      code: item?.codiceAnomalia,
      description: item?.descrizioneAnomalia,
      insertDate: item?.dataRegistrazioneAnomalia
        ? DateTime.fromISO(item?.dataRegistrazioneAnomalia).toFormat('dd/MM/yyyy')
        : '',
    })),
  };
};
